// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2jPFm","header":"MessagesList_header__f052f","chat":"MessagesList_chat__2GzLx"};